import { ORDER_ITEMS } from '../../namespace/order/order-items'
import { saveOrderState } from '../../../helpers/order-state'

export const orderItems = {
  state: {
    list: []
  },
  mutations: {
    [ORDER_ITEMS.MUTATIONS.SET_LIST](state, list) {
      state.list = list
      try {
        saveOrderState()
      } catch (e) {
        console.warn('Save order state error', e)
      }
    }
  },
  actions: {
    [ORDER_ITEMS.ACTIONS.CHANGE_ITEM]({ commit, state }, { action, item }) {

      const list = [...state.list]
      const targetIndex = list.findIndex(i => i.type === item.type)
      console.log(targetIndex, item)
      if (action === 'add') {
        const existIndex = list.findIndex(existItem => {
          return existItem.uuid === item.uuid && existItem.type === item.type
        })
        if (existIndex >= 0) {
          list[targetIndex] = item
          commit(ORDER_ITEMS.MUTATIONS.SET_LIST, list)
        } else {
          commit(ORDER_ITEMS.MUTATIONS.SET_LIST, [...list, item])
        }
        return
      }
      if (action === 'remove') {
        if (targetIndex >= 0) {
          state.list.splice(targetIndex, 1)
          commit(ORDER_ITEMS.MUTATIONS.SET_LIST, state.list)
        }
      }
      if (action === 'update') {
        if (targetIndex >= 0) {
          list[targetIndex] = item
          commit(ORDER_ITEMS.MUTATIONS.SET_LIST, list)
        }
      }
      if (action === 'update_quantity') {
        if (targetIndex >= 0) {
          list[targetIndex] = {
            ...list[targetIndex],
            quantity: item.quantity
          }
          commit(ORDER_ITEMS.MUTATIONS.SET_LIST, list)
        }
      }
    },
    [ORDER_ITEMS.ACTIONS.CLEAR_STORE]({ commit }) {
      commit(ORDER_ITEMS.MUTATIONS.SET_LIST, [])
    }
  },
  getters: {
    [ORDER_ITEMS.GETTERS.LIST](state) {
      return state.list
    }
  }
}
